import { CardContent, styled } from "@woba/ds-web";

export const CardContentStyle = styled(CardContent, {
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "$space-05",
});
